import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotLoggedInGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const access_token = localStorage.getItem(
      this.authService.ACCESS_TOKEN_KEY
    );
    const refresh_token = localStorage.getItem(
      this.authService.REFRESH_TOKEN_KEY
    );

    if (!(access_token && refresh_token)) {
      return true;
    }

    this.router.navigate(['']);
  }
}
